// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Layout } from '../../components/index';
import { Content } from './styles';
import Background from 'assets/images/ui-bg.webp';

export const UIUX = () => {
  const routePath = useLocation();

  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);

  return (
    <Layout noPadding>
      <Content>
        <img
          src={Background}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Content>
    </Layout>
  );
};
